import { collectStore } from "./store";
import { type CollectState } from "./store.types";

function getCollectOrderLines(): CollectState["orderLines"] {
  return collectStore.getState().orderLines;
}

function getCollectSuccessInfo(): CollectState["successInfo"] {
  return collectStore.getState().successInfo;
}

function getCollectFlow(): CollectState["flow"] {
  return collectStore.getState().flow;
}

function getStatusFilter(): CollectState["statusFilter"] {
  return collectStore.getState().statusFilter;
}

function getSearchBy(): CollectState["searchBy"] {
  return collectStore.getState().searchBy;
}

function getSelectedLetter(): CollectState["selectedLetter"] {
  return collectStore.getState().selectedLetter;
}

function getGroupPrimary(): CollectState["groupPrimary"] {
  return collectStore.getState().groupPrimary;
}

function getGroupSecondary(): CollectState["groupSecondary"] {
  return collectStore.getState().groupSecondary;
}

export {
  getCollectOrderLines,
  getCollectSuccessInfo,
  getCollectFlow,
  getStatusFilter,
  getSearchBy,
  getSelectedLetter,
  getGroupPrimary,
  getGroupSecondary
};
